import {Component, ViewChild} from '@angular/core';
import {AuthService} from '../../../services/auth/auth.service';
import {RouteService} from '../../../services/route/route.service';
import {MatMenuTrigger} from '@angular/material/menu';
import {ViewService} from '../../../services/view/view.service';
import {SalespointRoleComponent} from '../../../components/salespoint-role-component/salespoint-role.component';
import {Permission} from '../../../generated/sales-terminal-client';
import {uniqBy} from 'lodash-es';
import {Privileges} from '../../../modules/admin/privileges/privileges.constants';
import {SnackService} from "../../../services/snack/snack.service";
import {UtilService} from '../../../services/util/util.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent {
  @ViewChild('userMenuTrigger', {read: MatMenuTrigger}) public userMenuTrigger: MatMenuTrigger;
  @ViewChild('salespointRoleComponent') public salespointRoleComponent: SalespointRoleComponent;
  public Privileges = Privileges;

  constructor(
    public authService: AuthService,
    public routeService: RouteService,
    public viewService: ViewService,
    public utilService: UtilService,
    private snackService: SnackService
  ) { }

  public get salespoints(): Permission[] {
    return uniqBy(this.authService.permissions, 'salespointId');
  }

  public get isOpen(): boolean {
    return this.userMenuTrigger?.menuOpen;
  }

  public closeMenu(): void {
    this.userMenuTrigger.closeMenu();
  }

  public myProfile(): void {
    this.routeService.navigate('/app/profile');
  }

  public registerBusinessProfile(): void {
    this.routeService.navigate('/registration/legal-person');
  }

  public businessProfile(): void {
    this.routeService.navigate('/app/admin/legal-persons/view/' + this.authService.user.legalPersonId);
  }

  public logout(): void {
    this.snackService.clearAll();
    this.authService.userLogout();
  }
}
